import * as Services from "../models/swagger/generated-jobs-logging-service";

export const JobsLoggingService = {
    getAllJobs: Services.JobsService.all,
};
